<template>
  <z-page class="data-order">
    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>账号：</div>
        <div class="long">
          <el-input
            size="mini"
            v-model="search.masterAccount"
            placeholder="请输入账号"
            suffix-icon="el-icon-search"
          ></el-input>
        </div>
      </div>

      <div class="search-item">
        <div>产品名称：</div>
        <div class="long">
          <el-select size="mini" v-model="search.productKey" slot="prepend" placeholder="请选择">
            <el-option
              v-for="(item,index) in product"
              :key="index"
              :label="item.category_name"
              :value="item.ecsProduct.kfProductKey"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="search-item">
        <div>开通时间：</div>
        <div class="long">
          <el-date-picker
            v-model="search.start_time"
            size="mini"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          ></el-date-picker>-
          <el-date-picker
            v-model="search.end_time"
            size="mini"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
            value-format="timestamp"
          ></el-date-picker>
        </div>
      </div>
      <div @click="searchdata()" class="search-btn z-btn normal">搜索</div>
      <div @click="clearsear()" style="margin-left:20px;" class="search-btn">清除搜索</div>
    </div>

    <!-- 列表 -->
    <div class="page-list">
      <div class="list-head">
        <div>序号</div>
        <div>主账号</div>
        <div>消费账号</div>
        <div>客户经理</div>
        <div>产品名称</div>
        <div>套餐名称</div>
        <div>套餐单价</div>
        <div>开通价格</div>
        <div>开通时间</div>
        <div>订单类型</div>
        <div v-if="showLinxi">操作</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div v-for="(item, index) in data_list.list" :key="index" class="list-item">
          <div>{{ item.id }}</div>
          <div>{{ item.payAccount||'--'}}</div>
          <div>{{ item.openAccount||'--' }}</div>
          <div>{{ item.saleAccount||'--'}}</div>
          <div>{{ item.productName||'--' }}</div>
          <div>{{ item.mealName }}</div>
          <div>{{ item.mealUnitPrice|fix }}</div>

          <div>{{ item.orderPrice|fix }}</div>
          <div>{{ item.orderTime }}</div>
          <div>{{ item.orderType=='1'?'销售':'销售退货' }}</div>
          <div class="font-btn normal" @click="getMes(item.orderId)" v-if="showLinxi">详情</div>
        </div>
        <div
          class="list-item text"
        >共&nbsp;{{data_list.total}}&nbsp;笔订单；销售金额&nbsp;（资金：{{data_list.sales_amount | fix}}元）退订金额 （资金：{{data_list.unsubscribe_amount| fix}}元）</div>
      </div>
    </div>
    <!-- 分页 -->
    <z-pagination
      @sizeChange="getData()"
      @pageChange="handleCurrentChange"
      :current-page.sync="nowPage"
      :page-size="10"
      :total="total"
    ></z-pagination>
    <!-- 灵犀页面显示 -->
    <z-windowPop
      v-model="linxiFlag"
      width="650px"
      height="510px"
      @confirm="$func.shake(salefunc)"
      :black="true"
      :title="'灵翕订单详情页'"
      :noBtns="true"
      top="50%"
      
    >
      <div style="height:450px;width:630px">
        <div v-html="lingxiHTML">

        </div>
      </div>
    </z-windowPop>
  </z-page>
</template>

<script>
export default {
  data() {
    return {
      // 限制时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      showLinxi: false, //写死灵犀设计
      linxiFlag: false,
      lingxiHTML: "",
      loading: false,
      search: {
        //搜索框数据
        masterAccount: "", //主账号
        productName: "", //产品名称
        productKey: "", //产品钥匙
        start_time: new Date(new Date().getTime() - 30 * 24 * 3600000),
        end_time: ""
      },
      searching: {
        //实际搜索用到的容器 同上
        masterAccount: "",
        productName: "",
        productKey: "",
        start_time: new Date(new Date().getTime() - 30 * 24 * 3600000),
        end_time: ""
      },
      product: "",
      nowPage: 1, //当前页
      total: 1, //总数
      data_list: {
        //数据列表
        money_count: {
          //数据列表中的统计数据
          back_money: 0,
          back_new_coupons: 0,
          back_old_coupons: 0,
          pay_money: 0,
          pay_new_coupons: 0,
          pay_old_coupons: 0
        }
      }
    };
  },
  created() {
    this.$store.dispatch("getproduct").then(res => {
      if (res[0]) {
        this.searching.productKey = res[0].ecsProduct.kfProductKey;
        this.search.productKey = res[0].ecsProduct.kfProductKey;
        this.product = res;
      }
      this.getData(1);
    });
  },
  methods: {
    //灵犀方法
    getMes(val) {
       let url = `/supplier/order/info/from/kf`
      this.$http.get(url,{
        params:{
        order_id:val
      }}).then(res => {
        res=JSON.parse(res.res_data)
        console.log(res);
        
        if (res.msg == "success") {
          this.lingxiHTML = res.html;
          this.linxiFlag = true;
          this.$forceUpdate();
        } else {
          this.errorTip("请求失败");
        }
      })
      .catch(err=>{
        this.errorTip("请求失败");
      })
    },
    //搜索方法
    searchdata() {
      this.searching = this.search;
      this.handleCurrentChange(1);
    },
    //清除搜索条件方法
    clearsear() {
      this.searching = {
        productKey: this.product[0].ecsProduct.kfProductKey,
        masterAccount: "",
        start_time: new Date(new Date().getTime() - 30 * 24 * 3600000),
        end_time: "",
        productName: ""
      };
      this.search = {
        productKey: this.product[0].ecsProduct.kfProductKey,
        start_time: new Date(new Date().getTime() - 30 * 24 * 3600000)
      };
      this.nowPage = 1;
      this.handleCurrentChange(1);
    },
    // 当前页改变方法
    handleCurrentChange(val) {
      this.nowPage = val;
      this.getData();
    },
    //获取数据方法
    getData(num) {
      this.loading = true;
      let url = `/api/supplier/order/record/from/supplier`;
      this.$http
        .post(url, {
          categoryId: this.searching.productKey || null, //必填  key
          masterAccount: this.searching.masterAccount || null,
          nowPage: num || this.nowPage, // 必填   请求页
          openProductTimeOver:
            this.$func.myTimeToLocal(this.searching.end_time) ||
            this.$func.myTimeToLocal(
              new Date(new Date().getTime() + 24 * 3600 * 1000)
            ) ||
            null,
          openProductTimeStart:
            this.$func.myTimeToLocal(this.searching.start_time) || null,
          pages: "10", //每页数目
          productName: "" || null
        })
        .then(res => {
          this.showLinxi = this.searching.productKey == "lingxi" ? true : false;

          if (res.code == 200) {
            this.data_list = res.res_data;
            this.total = res.res_data.total;
          } else {
            this.errorTip(res.res_data);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.font {
  font-size: 14px;
  font-family: "PingFang-SC-Regular";
  color: rgba(89, 89, 89, 0.7);
  line-height: 40px;
}
.list-head,
.list-item {
  text-align: center;
  > div {
    &:nth-child(1) {
      width: 3%;
    }
    &:nth-child(2) {
      width: 12%;
    }
    &:nth-child(3) {
      width: 12%;
    }
    &:nth-child(4) {
      width: 7%;
    }
    &:nth-child(5) {
      width: 10%;
    }
    &:nth-child(6) {
      width: 14%;
    }
    &:nth-child(7) {
      width: 7%;
    }
    &:nth-child(8) {
      width: 7%;
    }
    &:nth-child(9) {
      width: 15%;
    }
    &:nth-child(10) {
      width: 8%;
    }
    &:nth-child(11) {
      width: 3%;
    }
  }
}
</style>
